$.fn.toggleDescription = function() {
  let self = this

  let selector = self.attr('class');

  $(self).click(function() {
    var max_height = self.find('.'+selector+'__description').outerHeight()
    self.find('.'+selector+'__expandable').css('--max-height', max_height + 'px')
    var max_height = self.find('.'+selector+'__image picture').outerHeight()
    self.find('.'+selector+'__image').css('--max-height', max_height + 'px')
    self.toggleClass('--expanded')
  });

  return function() {
    return self
  }()
};

$.fn.toggleDescriptionList = function() {
  let self = this

  let selector = self.attr('class');

  $(self).click(function() {
    var max_height = self.find('.'+selector+'__expandable-ruler').outerHeight()
    self.find('.'+selector+'__expandable').css('--max-height', max_height + 'px')
    self.toggleClass('--expanded')
  });

  return function() {
    return self
  }()
};

$.fn.toggleGridDisplays = function(result_selector) {
  let self = this

  $(self).click(function() {
    $('.js-ingredients-display-grid').removeClass('--selected');
    $(result_selector).find('.--expanded').removeClass('--expanded');
    $(result_selector).find('.card-ingredient__image').css('--max-height', '0');
    $(result_selector).find('.card-ingredient__expandable').css('--max-height', '0');
    self.addClass('--selected');
    //$(result_selector).addClass('--loading');
    if ($(this).hasClass('js-ingredients-display-grid--list')) {
      $(result_selector).addClass('--list');
    } else {
      $(result_selector).removeClass('--list');
    }

  });

  return function() {
    return self
  }()
};

$.fn.filterIngredients = function(result_selector) {
  let self = this

  $(self).find('.ingredients-header__categories__item').click(function() {
    if ($(this).attr('data-filter') == 'all') {
      var filter = '.grid__item'
    } else {
      var filter = '.category--' + $(this).attr('data-filter')
    }
    self.find('.ingredients-header__categories__selected').html($(this).html())
    $(self).find('.ingredients-header__categories__item').removeClass('--selected')
    $(this).addClass('--selected')
    $(result_selector).find('.grid__item').addClass('--hide');
    $(result_selector).find(filter).removeClass('--hide');
  });

  return function() {
    return self
  }()
};
